import { asdCombinations, lrfdCombinations, noCombinations } from "../load-combinations/load-combination";

export class DesignConfigurator {
  constructor() {
    this.northAmericanSteelMaterial = {
      'Type': 'AISC Steel', 'Name': 'A992', 'E': '29000', 'Fy': '50', 'Fu': '58', 'Density': '0.29'
    };
    this.europeanSteelMaterial = {
      // E = GPA, Fy and Fu = MPa, Density = kg/m^3
      "Type": "European Steel", "Name": "S355", "E": "200", "Fy": "355", "Fu": "490", "Density": "7800"
    };
    this.woodMaterial = {
      'Type': 'Visually Graded Lumber', 'Species': 'Alaska Cedar', 'Grade': 'Select Structural',
      'Fb': '1150.0', 'Ft': '625.0', 'Fv': '165.0', 'Fcp': '525.0', 'Fc': '1000.0',
      'E': '1400000.0', 'Emin': '510000.0', 'G': '0.47'
    };
    this.engineeredLumberMaterial = {
      "Grade": "1.3E", "Type": "TimberStrand LSL", "G": "81250", "E": "1300", "Emin": "660750",
      "Fb": "1700", "Ft": "1300", "Fc perpendicular": "710", "Fc parallel": "1835", "Fv": "425",
      "SG": "0.5"
    };
    this.customMaterial = {
      'Type': 'Custom', 'Name': 'Custom', 'E': '29000', 'Fy': 50, 'Ix': 48, 'Sx': 11.8
    };
    this.customAluminumMaterial = {
      "Type": "Aluminum", "Name": "6061 Alloy T6", "E": "10000", "Fy": "40", "Fu": "45", "Density": "0.0975"
    };
    this.customSoldierMaterial = {
      "Type": "ASTM Steel", "Name": "A570 Gr. 50", "E": "29000", "Fy": "50", "Fu": "65.3", "Density": "0.282"
    };
    this.customSoldierWalerMaterial = {
      "Type": "ASTM Steel", "Name": "A36", "E": "29000", "Fy": "36", "Fu": "58-80", "Density": "0.29"
    };
    this.northAmericanSteelShape = {
      "Type": "W", "EDI_Std_Nomenclature": "W8X15", "AISC_Manual_Label": "W8X15", "T_F": "F", "W": "15.0",
      "A": "4.44", "d": "8.11", "ddet": "8.13", "Ht": "0", "OD": "0", "bf": "4.02", "bfdet": "4.00", "B": "0",
      "ID": "0", "tw": "0.245", "twdet": "0.25", "twdet/2": "0.13", "tf": "0.315", "tfdet": "0.31", "t": "0",
      "tnom": "0", "tdes": "0", "kdes": "0.615", "kdet": "0.81", "k1": "0.56", "x": "0", "y": "0", "eo": "0",
      "xp": "0", "yp": "0", "bf/2tf": "6.37", "B/t": "0", "h/tw": "28.1", "Ht/t": "0", "D/t": "0", "Ix": "48.0",
      "Zx": "13.6", "Sx": "11.8", "rx": "3.29", "Iy": "3.41", "Zy": "2.67", "Sy": "1.70", "ry": "0.876", "rz": "0",
      "Sz": "0", "J": "0.137", "Cw": "51.8", "C": "0", "Wno": "7.81", "Sw": "2.47", "Qf": "2.31", "Qw": "6.64",
      "ro": "0", "H": "0", "tan_alpha": "0", "Qs": "0"
    };
    this.europeanSteelShape = {
      "Profile": "HEA100", "h": "96", "b": "100", "W": "16.7", "A": "2124",
      "Ix": "3.492", "Sx": "72.76", "Zx": "83.01", "rx": "40.6", "Iy": "1.338",
      "Sy": "26.76", "Zy": "41.14", "ry": "25.1", "Type": "W"
    };
    this.woodShape = {
      "Name": "2x4", "b": "1.5", "d": "3.5", "A": "5.25", "Sx": "3.0625", "Ix": "5.359375", "Sy": "1.3125",
      "Iy": "0.984375", "b_base_shape": "1.5", "Type": "Lumber"
    };
    this.engineeredLumberShape = {
      "Grade": "1.3E", "Type": "TimberStrand LSL", "Width": "3 1/2\"", "Height": "4 3/8\"",
      "w": "3.5", "h": "4.375", "Moment": "1735", "Shear": "4340", "Ix": "24", "W": "4.5"
    };
    this.customShape = {
      'Type': 'Custom', 'Name': "Custom Shape", 'A': 4.44, 'Ix': 48, 'Sx': 11.8, 'W': 15
    };
    this.customAluminumShape = {
      'Name': '6.5" Aluminum Joist', 'A': 2.7, 'Ix': 17, 'Sx': 5.23, 'Type': 'Custom Aluminum'
    };
    this.customSoldierShape = {
      'Name': 'Continuous Single Member', 'A': 4, 'Ix': 56.5, 'Sx': 12.56, 'Iy': 27.5, 'Sy': 6.12,
      'Type': 'Dayton Superior Soldier'
    };

    this.northAmericanSteelDesign = "LRFD";
    this.northAmericanWoodDesign = "LRFD";
    this.europeanSteelDesign = "None";
    this.customDesign = "None";
    this.customAluminumDesign = "None";
    this.customSoldierDesign = "None";
    //this.engineeredLumberDesign = "engineeredLumberDesign"
    this.engineeredLumberDesign = "LRFD"

    this.northAmericanSteel = "North American Steel";
    this.europeanSteel = "European Steel";
    this.northAmericanWood = "North American Wood";
    this.custom = "Custom";
    this.customAluminum = "Custom Aluminum";
    this.customSoldier = "Custom Soldier";
    this.engineeredLumber = "Engineered Lumber";

    this.northAmericanSteelSelected();
  }

  northAmericanSteelSelected() {
    this.shape = this.northAmericanSteelShape;
    this.material = this.northAmericanSteelMaterial;
    this.design = this.northAmericanSteelDesign;
    this.type = this.northAmericanSteel;
  }

  europeanSteelSelected() {
    this.shape = this.europeanSteelShape;
    this.material = this.europeanSteelMaterial;
    this.design = this.europeanSteelDesign;
    this.type = this.europeanSteel;
  }

  woodSelected() {
    this.shape = this.woodShape;
    this.material = this.woodMaterial;
    this.design = this.northAmericanWoodDesign;
    this.type = this.northAmericanWood;
    //onHasSteelPlatesChange()
  }

  engineeredLumberSelected() {
    this.shape = this.engineeredLumberShape;
    // shape determines the material...
    for (var i in engineeredLumberMaterials) {
      if (engineeredLumberMaterials[i]["Grade"] === this.shape["Grade"] &&
        engineeredLumberMaterials[i]["Type"] === this.shape["Type"]) {
        this.material = engineeredLumberMaterials[i];
        break;
      }
    }
    this.design = this.engineeredLumberDesign;
    this.type = this.engineeredLumber;
    //onHasSteelPlatesChange()
  }

  customShapeSelected() {
    this.shape = this.customShape;
    this.material = this.customMaterial;
    this.design = this.customDesign;
    this.type = this.custom;
  }

  customAluminumSelected() {
    this.shape = this.customAluminumShape;
    this.material = this.customAluminumMaterial;
    this.design = this.customAluminumDesign;
    this.type = this.customAluminum;
  }

  customSoldierSelected() {
    this.shape = this.customSoldierShape;
    if ('Continuous Single Member' === this.shape['Name'] || 'Two Continuous Stacked' === this.shape['Name']) {
      this.material = this.customSoldierMaterial;
    } else {
      this.material = this.customSoldierWalerMaterial;
    }
    this.design = this.customSoldierDesign;
    this.type = this.customSoldier;
  }

  asdCombinationsSelected() {
    this.northAmericanSteelDesign = "ASD";
    this.northAmericanWoodDesign = "ASD";
    this.engineeredLumberDesign = "ASD";
    this.design = "ASD";
  }

  lrfdCombinationsSelected() {
    this.northAmericanSteelDesign = "LRFD";
    this.northAmericanWoodDesign = "LRFD";
    this.engineeredLumberDesign = "LRFD";
    this.design = "LRFD";
  }
  setShapeMaterialAndDesign(project) {
    project.shape = this.shape
    project.material = this.material

    project.design.designType = this.design

    switch(this.design) {
      case 'None':
        project.design.loadCombination = noCombinations
        break
      case 'LRFD':
        project.design.loadCombination = lrfdCombinations
        break
      case 'ASD':
        project.design.loadCombination = asdCombinations
        break
    }
  }

  get shapeName() {
    switch (this.type) {
      case this.northAmericanWood:
        return this.shape['Name'];
      case this.northAmericanSteel:
        return this.shape['AISC_Manual_Label'];
      case this.europeanSteel:
        return this.shape['Profile'];
      case this.custom:
        return this.shape['Name'];
      case this.engineeredLumber:
        return data[i]['Type'] + " " + data[i]['Grade'] + " " + data[i]['Width'] + " &times; " + data[i]['Height'];
      default:
        return this.shape['Name'];
    }
  }

  get materialName() {
    switch (this.type) {
      case this.northAmericanWood:
        return this.material['Species'];
      case this.northAmericanSteel:
        return "Steel " + this.material['Name'];
      case this.europeanSteel:
        return "Steel " + this.material['Name'];
      case this.engineeredLumber:
        return this.material['Grade'] + " " + this.material['Type'];
      default:
        return this.material['Name'];
    }
  }

  get shapeType() {
    return this.shape['Type'];
  }

  get designName() {
    switch (this.type) {
      case this.northAmericanWood:
        return 'Wood ' + this.design;
      case this.northAmericanSteel:
        return 'Steel ' + this.design;
      case this.europeanSteel:
        return 'Basic Design';
      case this.engineeredLumber:
        return this.design;
      default:
        return 'Basic Design';
    }
  }
}
